import HeaderScrolled from '../../../helper/header-scrolled';
import ScrollTo from '../../../helper/scroll-to';

const PostPage = {
  init() {
    this._scrollToInit();
    this._headerScrolledInit();
  },


  _scrollToInit() {
    ScrollTo.init();
  },


  _headerScrolledInit() {
    HeaderScrolled.init();
  }
};

export default PostPage;